"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class OIDCHelper {
    constructor($window) {
        this.$window = $window;
        this.openidConfigPath = "/.well-known/openid-configuration";
        this.stateStorageKey = "oidc.state";
        this.nonceStorageKey = "oidc.nonce";
        this.phoneStorageKey = "oidc.phoneNumber";
    }
    buildServiceUrl() {
        let baseUrl = `${this.$window.location.protocol}//${this.$window.location.host}${this.$window.location.pathname}${this.$window.location.hash}`;
        return baseUrl.replace("#!/login", "").split("?")[0];
    }
    randomToken() {
        let bytes = new Uint8Array(16);
        this.$window.crypto.getRandomValues(bytes);
        return Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
    }
    buildConfigUrl(serverUrl) { return serverUrl + this.openidConfigPath; }
    buildLoginUrl(OIDCServerConfiguration, phoneNumber, clientId, scope) {
        let nonce = this.randomToken();
        let state = this.randomToken();
        this.$window.sessionStorage.setItem(this.nonceStorageKey, nonce);
        this.$window.sessionStorage.setItem(this.stateStorageKey, state);
        this.$window.sessionStorage.setItem(this.phoneStorageKey, phoneNumber || "");
        return `${OIDCServerConfiguration.data.authorization_endpoint}?` +
            'client_id=' + encodeURIComponent(clientId) +
            '&redirect_uri=' + encodeURIComponent(this.buildServiceUrl()) +
            '&response_type=token+id_token' +
            '&response_mode=fragment' +
            '&scope=' + encodeURIComponent(scope || 'openid profile email') +
            '&nonce=' + encodeURIComponent(nonce) +
            '&state=' + encodeURIComponent(state);
    }
    buildLogoutParameter(clientId, idToken) {
        return idToken ? `&id_token_hint=${idToken}` : `&client_id=${encodeURIComponent(clientId)}`;
    }
    buildLogoutUrl(OIDCServerConfiguration, clientId, idToken) {
        return `${OIDCServerConfiguration.data.end_session_endpoint}` +
            "?post_logout_redirect_uri=" +
            encodeURIComponent(this.buildServiceUrl()) +
            this.buildLogoutParameter(clientId, idToken);
    }
    clearStoredValues() {
        this.$window.sessionStorage.removeItem(this.stateStorageKey);
        this.$window.sessionStorage.removeItem(this.nonceStorageKey);
        this.$window.sessionStorage.removeItem(this.phoneStorageKey);
    }
    storePhoneNumber(phoneNumber) {
        this.$window.sessionStorage.setItem(this.phoneStorageKey, phoneNumber || "");
    }
    clearStoredPhoneNumber() {
        this.$window.sessionStorage.removeItem(this.phoneStorageKey);
    }
    getStoredPhoneNumber() {
        let phoneNumber = this.$window.sessionStorage.getItem(this.phoneStorageKey);
        return phoneNumber ? phoneNumber : undefined;
    }
    isStateValid(url) {
        let returnedState = Object.fromEntries(new URLSearchParams(url.split('?')[1])).state;
        let expectedState = this.$window.sessionStorage.getItem(this.stateStorageKey);
        return !!expectedState && returnedState === expectedState;
    }
    isNonceValid(idToken) {
        let expectedNonce = this.$window.sessionStorage.getItem(this.nonceStorageKey);
        if (!expectedNonce)
            return false;
        return this.getClaimFromIdToken(idToken, "nonce") === expectedNonce;
    }
    getClaimFromIdToken(idToken, claim) {
        if (!idToken)
            return undefined;
        let parts = idToken.split(".");
        if (parts.length < 2)
            return undefined;
        let payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        payload += "=".repeat((4 - payload.length % 4) % 4);
        try {
            let decoded = JSON.parse(this.$window.atob(payload));
            return decoded ? decoded[claim] : undefined;
        }
        catch (e) {
            return undefined;
        }
    }
}
exports.default = OIDCHelper;
OIDCHelper.$inject = ["$window"];
